import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";

function Roaming(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1c1.103 0 2 .897 2 2v2.373a1 1 0 01-1 1h-.001L3 6.363v10.032h4.251a1 1 0 110 2H3V21h10.5v-1.297a1 1 0 112 0V21c0 1.102-.897 2-2 2H3c-1.103 0-2-.898-2-2V3c0-1.103.897-2 2-2h10.5zM8.202 18.753a.95.95 0 110 1.901.95.95 0 010-1.9zm4.546-10.205c.468 0 .912.047 1.333.137.42.092.788.242 1.105.455.316.213.567.498.754.858.186.361.279.808.279 1.345 0 .651-.17 1.203-.507 1.66a2.136 2.136 0 01-1.014.738.394.394 0 00-.198.574l1.705 2.832a.4.4 0 01-.343.607H14.38a.4.4 0 01-.354-.215l-1.812-3.465h-1.001v3.28a.4.4 0 01-.4.4H9.586a.4.4 0 01-.4-.4V8.948a.4.4 0 01.4-.4h3.162zm6.712-4.343c.868.492 2.44 1.664 3.218 3.99.772 2.303.255 4.167-.12 5.073a1 1 0 11-1.848-.768c.27-.647.636-1.985.072-3.67-.567-1.693-1.69-2.534-2.308-2.884a1.001 1.001 0 01.986-1.741zM17.672 6.64l.025.01.08.036c.371.173 1.507.817 2.048 2.434.626 1.87-.126 3.166-.214 3.307a.998.998 0 01-1.376.325 1 1 0 01-.334-1.362c.027-.049.35-.673.04-1.603-.33-.98-.983-1.278-1.01-1.289a1.01 1.01 0 01-.533-1.302.988.988 0 011.274-.556zm-5.132 3.624h-1.326v2.094h1.196c.182 0 .375-.008.578-.02.204-.013.389-.052.553-.117a.974.974 0 00.41-.306c.108-.139.162-.334.162-.584 0-.235-.047-.42-.143-.56a.961.961 0 00-.364-.319 1.627 1.627 0 00-.507-.149 4.309 4.309 0 00-.56-.039zM13.5 3H3v1.363l10.5.01V3z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

var MemoRoaming = React.memo(Roaming);
export default MemoRoaming;